import { render, staticRenderFns } from "./LoginEmpresa.vue?vue&type=template&id=b6e87b02&"
import script from "./LoginEmpresa.vue?vue&type=script&lang=js&"
export * from "./LoginEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports